import React from 'react';
import { AiFillDollarCircle } from 'react-icons/ai';

const BadOtros = ({ otros, meses }) => {
    return (
        <div>
            {otros.map((ot, i) => (
                <div className="alert text-white" style={{ background: '#aa16aa' }} role="alert" key={i + 'pay'}>
                    <div>
                        <span className="font-medium">
                            <AiFillDollarCircle className="fs-3 mx-2" />
                            Cargo por servicio personalizado{' '}
                            <span className="bg-green text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                {`$${ot.precio} x ${meses} = $${parseFloat(ot.precio) * meses}`}{' '}
                                {`$${ot.precio} x ${meses}  = $${meses * parseFloat(ot.precio)} {' '}`}
                            </span>
                        </span>{' '}
                        {ot.nombre} <br /> {ot.descripcion}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BadOtros;
